export const SHOW_REQUEST_ACCESS_CONFIRMATION =
  'SHOW_REQUEST_ACCESS_CONFIRMATION'
export const showConfirmation = (payload) => ({
  type: SHOW_REQUEST_ACCESS_CONFIRMATION,
  payload,
})
